import type {
  Salary,
  SalaryDto,
  SalaryTimelineResponse,
  SalaryTimelineResponseDto,
} from '@src/features/users/types';
import { rankFromDto } from './rank';

export function salaryFromDto(salary: SalaryDto): Salary {
  return {
    id: salary.id ?? '',
    startDate: salary.saly_start ?? '',
    endDate: salary.saly_end ?? null,
    rank: salary.saly_rank ? rankFromDto(salary.saly_rank) : null,
    percentage: salary.saly_percentage ?? 0,
    salaryType: salary.saly_monthly_salary ? 'monthly' : 'hourly',
    monthly: salary.saly_monthly,
    hourly: salary.saly_hourly,
    isActive: Boolean(salary.is_active),
  };
}

export function salaryTimelineResponseFromDto(
  response: SalaryTimelineResponseDto,
): SalaryTimelineResponse {
  return {
    requiresConfirmation: response.requires_confirmation,
    results: (response.results ?? []).map(salaryFromDto),
    affectedRecords: response.affected_records ?? [],
    finalState: response.final_state ?? [],
  };
}
